var ReactDOM = require('react-dom');
var App = require('./app/components/App');
require('./app/global.scss');

ReactDOM.render(
    <App />,
    document.getElementById('app')
);


// WEBPACK FOOTER //
// ./index.js